import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8dd8c4f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { slot: "label" }
const _hoisted_2 = { class: "ion-text-center ion-margin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_back_button, {
                "default-href": "/tabs/find-groups",
                slot: "start"
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("New group")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("main", null, [
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate('Create a new group')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          "label-placement": "floating",
                          onIonBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setFacilityGroupId($event))),
                          modelValue: _ctx.formData.facilityGroupName,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.facilityGroupName) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                              _createTextVNode(_toDisplayString(_ctx.translate("Name")) + " ", 1),
                              _createVNode(_component_ion_text, { color: "danger" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("*")
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { lines: "none" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          "label-placement": "floating",
                          label: _ctx.translate('Internal ID'),
                          ref: "facilityGroupId",
                          modelValue: _ctx.formData.facilityGroupId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.facilityGroupId) = $event)),
                          onIonInput: _ctx.validateFacilityGroupId,
                          onIonBlur: _ctx.markFacilityGroupIdTouched,
                          "error-text": _ctx.translate('Internal ID cannot be more than 20 characters.')
                        }, null, 8, ["label", "modelValue", "onIonInput", "onIonBlur", "error-text"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select, {
                          label: _ctx.translate('Group type'),
                          disabled: _ctx.isFacilityGroupTypeDisabled,
                          placeholder: _ctx.translate('Select'),
                          interface: "popover",
                          modelValue: _ctx.formData.facilityGroupTypeId,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.facilityGroupTypeId) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilityGroupTypes, (facilityGroupType) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                value: facilityGroupType.facilityGroupTypeId,
                                key: facilityGroupType.facilityGroupTypeId
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(facilityGroupType.description ?  facilityGroupType.description : facilityGroupType.facilityGroupTypeId), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["label", "disabled", "placeholder", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        (_ctx.productStores.length)
                          ? (_openBlock(), _createBlock(_component_ion_select, {
                              key: 0,
                              label: _ctx.translate('Product store'),
                              placeholder: _ctx.translate('Select'),
                              selectedText: _ctx.selectedProductStoreIds.length > 1 ? _ctx.translate('product stores', { count: _ctx.selectedProductStoreIds.length }) : _ctx.selectedProductStoreIds.map[0],
                              value: _ctx.selectedProductStoreIds,
                              onIonChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateFacilityGroupProductStores($event))),
                              multiple: true
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStores, (productStore) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    value: productStore.productStoreId,
                                    key: productStore.productStoreId
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(productStore.storeName ? productStore.storeName : productStore.productStoreId), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["label", "placeholder", "selectedText", "value"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { lines: "none" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_textarea, {
                          label: _ctx.translate('Description'),
                          "label-placement": "floating",
                          placeholder: _ctx.translate('group description'),
                          "auto-grow": true,
                          counter: true,
                          maxlength: 255,
                          modelValue: _ctx.formData.description,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.description) = $event))
                        }, null, 8, ["label", "placeholder", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_ion_button, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createFacilityGroup()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("Create group")) + " ", 1),
                  _createVNode(_component_ion_icon, {
                    slot: "end",
                    icon: _ctx.arrowForwardOutline
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}